@if (loadingService.isLoading()) {
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
    <p>Loading...</p>
  </div>
}
